import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c(VProgressLinear,{attrs:{"indeterminate":"","color":"primary"}}):_c('router-view',{attrs:{"place":_vm.place}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }